import React from 'react';
import PropTypes from 'prop-types';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classNames from 'classnames';

const Tabs = ({ tabs, activeTab, onTabClick }) => (
  <div>
    <Nav tabs>
      {tabs.map(({ title }, index) => {
        const tabId = `${index + 1}`;
        return (
          <NavItem key={tabId}>
            <NavLink
              className={classNames({ active: activeTab === tabId })}
              onClick={() => {
                onTabClick(tabId);
              }}
            >
              {title}
            </NavLink>
          </NavItem>
        );
      })}
    </Nav>
    <TabContent activeTab={activeTab}>
      {tabs.map(({ render }, index) => {
        const tabId = `${index + 1}`;
        return (
          <TabPane tabId={tabId} key={tabId}>
            {render}
          </TabPane>
        );
      })}
    </TabContent>
  </div>
);

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      render: PropTypes.node,
    }).isRequired
  ),
  onTabClick: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default Tabs;
